import "./ProgressBar.css";
import BaseComponent from "../BaseComponent";
import PropTypes from "prop-types";
import {Box, LinearProgress, Typography} from "@mui/material";

class ProgressBar extends BaseComponent {

  render() {
    return (<Box sx={{display: 'flex', alignItems: 'center'}}>
      <Box sx={{width: '100%', mr: 1}}>
        <LinearProgress variant="determinate" value={this.props.progress}/>
      </Box>
      <Box sx={{minWidth: 35}}>
        <Typography variant="body2" sx={{color: 'text.secondary'}}>
          {`${Math.round(this.props.progress)}%`}
        </Typography>
      </Box>
    </Box>);
  }
}

ProgressBar.propTypes = {
  text: PropTypes.string, progress: PropTypes.number
};
export default ProgressBar;
